export const PROPERTY_FAQ_CATEGORIES = [
  { id: 'umum', label: 'Tentang Dihaw.co' },
  { id: 'pencarian', label: 'Mencari properti' },
  { id: 'listing', label: 'Memasang listing' },
  { id: 'bantuan', label: 'AI, KPR, dan bantuan' },
] as const

export type PropertyFaqItem = {
  id: string
  category: typeof PROPERTY_FAQ_CATEGORIES[number]['id']
  question: string
  answer: string
}

export const PROPERTY_FAQS: readonly PropertyFaqItem[] = [
  {
    id: 'apa-itu-dihaw', category: 'umum',
    question: 'Apa itu Dihaw.co?',
    answer: 'Dihaw.co adalah platform pencarian dan pemasangan listing properti di Indonesia. Kamu dapat melihat informasi properti, membandingkan pilihan, memakai fitur berbantu AI, dan menghubungi pemasang langsung.',
  },
  {
    id: 'untuk-siapa', category: 'umum',
    question: 'Siapa yang bisa menggunakan Dihaw.co?',
    answer: 'Dihaw.co dapat digunakan oleh pencari rumah, penyewa, pemilik properti, agen, dan developer. Bank serta bisnis pendukung properti juga dapat menjajaki kerja sama melalui halaman Partner.',
  },
  {
    id: 'jenis-properti', category: 'umum',
    question: 'Jenis properti apa saja yang tersedia?',
    answer: 'Kategori properti mencakup rumah, apartemen, tanah, ruko, vila, gudang, dan ruang usaha. Ketersediaan tiap jenis properti dan lokasi mengikuti listing yang sedang aktif.',
  },
  {
    id: 'akun-pencarian', category: 'umum',
    question: 'Apakah harus punya akun untuk mencari properti?',
    answer: 'Kamu dapat membuka halaman pencarian dan detail properti publik tanpa masuk ke akun. Untuk memasang serta mengelola listing, masuk melalui Pasang Properti atau Login sebagai Agen.',
  },
  {
    id: 'peran-platform', category: 'umum',
    question: 'Apakah Dihaw.co menjual properti secara langsung?',
    answer: 'Dihaw.co menyediakan platform listing dan informasi, bukan pihak dalam transaksi properti. Ketersediaan, survei, negosiasi, dokumen, dan pembayaran perlu dibicarakan langsung dengan pemasang atau pihak yang berwenang.',
  },
  {
    id: 'cara-mencari', category: 'pencarian',
    question: 'Bagaimana cara mencari properti di Dihaw.co?',
    answer: 'Pilih menu Dijual, Disewa, atau Properti Baru. Masukkan lokasi atau kata kunci, lalu gunakan filter yang tersedia untuk mempersempit pilihan. Buka detail listing untuk melihat foto, spesifikasi, dan kontak pemasang.',
  },
  {
    id: 'jual-dan-sewa', category: 'pencarian',
    question: 'Apakah bisa mencari properti untuk disewa?',
    answer: 'Bisa. Gunakan menu Disewa untuk melihat listing sewa. Periksa harga, periode sewa, fasilitas, serta ketentuan yang dicantumkan, lalu konfirmasikan detailnya kepada pemasang.',
  },
  {
    id: 'kontak-pemasang', category: 'pencarian',
    question: 'Bagaimana menghubungi pemilik atau agen?',
    answer: 'Buka halaman detail properti dan gunakan pilihan kontak yang tersedia, seperti WhatsApp, telepon, atau formulir pertanyaan. Sebutkan properti yang kamu minati agar pemasang dapat menindaklanjuti dengan lebih jelas.',
  },
  {
    id: 'jadwal-survei', category: 'pencarian',
    question: 'Bagaimana menjadwalkan survei properti?',
    answer: 'Hubungi pemasang melalui kontak pada listing untuk menyepakati waktu dan lokasi survei. Konfirmasikan kembali jadwal serta ketersediaan properti sebelum berangkat; Dihaw.co tidak menetapkan jadwal survei untuk pemasang.',
  },
  {
    id: 'harga-ketersediaan', category: 'pencarian',
    question: 'Apakah harga dan ketersediaan properti selalu terbaru?',
    answer: 'Informasi listing berasal dari pemasang dan dapat berubah. Konfirmasikan harga, ketersediaan, kondisi, serta rincian biaya langsung kepada pemasang sebelum melanjutkan proses.',
  },
  {
    id: 'cara-pasang', category: 'listing',
    question: 'Bagaimana cara memasang properti?',
    answer: 'Buka Pasang Properti, masuk ke akun, lalu lengkapi informasi dan foto properti. Periksa harga, lokasi, spesifikasi, dan nomor kontak sebelum mengirim listing untuk ditinjau.',
  },
  {
    id: 'materi-listing', category: 'listing',
    question: 'Apa yang perlu disiapkan sebelum memasang listing?',
    answer: 'Siapkan foto properti yang jelas, jenis dan tujuan listing, harga, lokasi, luas, spesifikasi, deskripsi, serta kontak aktif. Isi informasi sesuai keadaan sebenarnya dan pastikan kamu berwenang memasarkan properti tersebut.',
  },
  {
    id: 'biaya-listing', category: 'listing',
    question: 'Apakah memasang listing dikenakan biaya?',
    answer: 'Biaya mengikuti jenis akun, paket, dan program yang sedang berlaku. Periksa penawaran yang ditampilkan saat memasang properti atau memilih paket. Featured listing dan penggunaan AI tertentu dapat memiliki biaya atau kredit terpisah.',
  },
  {
    id: 'peninjauan-listing', category: 'listing',
    question: 'Mengapa listing saya belum tampil?',
    answer: 'Periksa status listing di akunmu. Listing yang masih berupa draf, menunggu peninjauan, ditolak, tidak aktif, atau kedaluwarsa belum tentu tampil di pencarian publik. Ikuti catatan perbaikan yang tersedia atau hubungi dukungan jika perlu bantuan.',
  },
  {
    id: 'ubah-listing', category: 'listing',
    question: 'Bagaimana memperbarui listing atau menandainya sudah terjual?',
    answer: 'Buka pengelolaan listing di akunmu, pilih properti, lalu gunakan tindakan edit atau perubahan status yang tersedia. Perbarui harga, foto, dan kontak bila berubah; tandai properti yang sudah terjual atau nonaktifkan listing yang tidak lagi ditawarkan. Perubahan tertentu dapat memerlukan peninjauan ulang.',
  },
  {
    id: 'fitur-ai', category: 'bantuan',
    question: 'Apa kegunaan fitur AI di Dihaw.co?',
    answer: 'Fitur AI membantu pekerjaan seperti merapikan informasi listing dan mengolah materi visual melalui alat yang tersedia. Hasil AI perlu diperiksa sebelum digunakan agar deskripsi dan tampilan properti tetap sesuai kondisi sebenarnya.',
  },
  {
    id: 'kredit-ai', category: 'bantuan',
    question: 'Bagaimana mengetahui kebutuhan kredit AI?',
    answer: 'Periksa saldo, pilihan isi ulang, dan informasi penggunaan pada halaman AI Tools di akunmu. Kebutuhan kredit mengikuti alat atau proses yang dipilih. Tinjau informasi yang tampil sebelum menjalankan proses atau membeli kredit.',
  },
  {
    id: 'simulasi-kpr', category: 'bantuan',
    question: 'Apakah hasil simulasi KPR merupakan persetujuan bank?',
    answer: 'Tidak. Simulasi KPR konvensional dan syariah di Dihaw.co menghasilkan estimasi berdasarkan data yang kamu masukkan. Hasilnya bukan persetujuan pembiayaan atau penawaran bank. Konfirmasikan ketentuan dan perhitungan akhir dengan bank terkait.',
  },
  {
    id: 'jadi-partner', category: 'bantuan',
    question: 'Bagaimana menjadi partner Dihaw.co?',
    answer: 'Buka halaman Partner dan pilih kebutuhan sebagai developer, agen, atau mitra pembiayaan. Hubungi tim melalui WhatsApp atau email dengan informasi usaha, area layanan, dan tujuan kerja sama.',
  },
  {
    id: 'hubungi-dukungan', category: 'bantuan',
    question: 'Bagaimana meminta bantuan atau melaporkan listing bermasalah?',
    answer: 'Kirim email ke hello@dihaw.ai dengan tautan listing atau halaman terkait serta penjelasan masalah. Sertakan tangkapan layar bila diperlukan, tetapi jangan kirim kata sandi, kode OTP, atau data pembayaran sensitif.',
  },
]

const HOME_FAQ_IDS = ['apa-itu-dihaw', 'akun-pencarian', 'kontak-pemasang', 'cara-pasang', 'biaya-listing', 'fitur-ai']
export const HOME_PROPERTY_FAQS = HOME_FAQ_IDS.map((id) => PROPERTY_FAQS.find((item) => item.id === id)!)

export const PROPERTY_FAQ_SEO = {
  title: 'FAQ Dihaw.co - Pertanyaan Seputar Properti, Listing, dan AI',
  description: 'Temukan jawaban atas 20 pertanyaan tentang Dihaw.co: mencari properti, menghubungi agen, memasang listing, biaya, fitur AI, simulasi KPR, dan bantuan.',
  keywords: 'FAQ Dihaw.co, bantuan Dihaw.co, pertanyaan listing properti, cara pasang properti, pencarian properti, AI properti',
}

export function buildPropertyFaqSchema(items: readonly PropertyFaqItem[] = PROPERTY_FAQS, path = '/faq') {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    '@id': `https://dihaw.co${path}#faq`,
    url: `https://dihaw.co${path}`,
    inLanguage: 'id-ID',
    mainEntity: items.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: { '@type': 'Answer', text: item.answer },
    })),
  }
}
